import React from 'react';
import clsx from 'clsx';
import MuiCardHeader from '@material-ui/core/CardHeader';
import { CARD_HEADER } from 'ctsutheme/core';

const CardHeader = ({ className, ...props }) => (
  <MuiCardHeader
    className={clsx(CARD_HEADER.root, className)}
    {...props}
  />
);

export default CardHeader;
